const IconCostRelief = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48">
    <polyline
      points="4 40 12 30 20 35 28 20 36 25 44 10"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2.5"
    />
    <line
      x1="3"
      y1="45"
      x2="46"
      y2="45"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2.5"
    />
    <circle cx="12" cy="30" r="2" fill="currentColor" />
    <circle cx="20" cy="35" r="2" fill="currentColor" />
    <circle cx="28" cy="20" r="2" fill="currentColor" />
    <circle cx="36" cy="25" r="2" fill="currentColor" />
    <circle cx="44" cy="10" r="2" fill="currentColor" />
  </svg>
);

export default IconCostRelief;